<template>
  <div class="flex justify-center items-center min-h-[50vh] px-4 py-20 lg:px-20">
    <div class="flex flex-wrap gap-x-4 gap-y-12 justify-center">
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-blue-700 to-blue-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-users text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Użytkownicy</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.users }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">2 </span>zalogowanych</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-indigo-700 to-indigo-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-building text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Realizatorzy usług</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.providers }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+2 </span>nowych w tym miesiącu</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-teal-700 to-teal-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-icons text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Kategorie</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.categories }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+1 </span>dodana kategoria</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-purple-700 to-purple-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-hand-pointer text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Typy</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.types }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+4 </span>nowe typy</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-green-700 to-green-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-plug-circle-check text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Usługi</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.services }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+2 </span>nowe usługi</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-pink-700 to-pink-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-stamp text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Protokoły typu A</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.aProts }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+1 </span>nowy protokół A</p>
          </div>
        </div>
      </div>
      <div class="flex w-72">
        <div class="flex w-full max-w-full flex-col break-words border border-gray-100 bg-white rounded-md shadow-md text-gray-600 relative">
          <div class="p-3">
            <div class="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-orange-700 to-orange-500 text-center text-white shadow-lg flex items-center justify-center">
              <i class="fa-solid fa-stamp text-xl mt"></i>
            </div>
            <div class="pt-1 text-right">
              <p class="text-sm font-light capitalize">Protokoły typu B</p>
              <h4 class="text-2xl font-semibold tracking-tighter xl:text-2xl">{{ systemData.bProts }}</h4>
            </div>
          </div>
          <hr class="opacity-50" />
          <div class="py-1 px-3">
            <p class="font-light"><span class="text-sm font-bold text-green-600">+1 </span>nowy protokół B</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { setStoreValue } from "@pages/Helper/utils.js";

const props = defineProps({
    systemName: String,
    currentModule: String,
    systemData: Object,
});

setStoreValue("currentModule", props.currentModule);
</script>

<style scoped>

</style>
